import RegVehHeader from "./Header";
import "./index.css";
import { useState } from "react";
import { ShowHide } from "../components/ShowHideCompany";
import NonFuelVehicle from "./NonFuelVehicle";
import FuelVehicle from "./FuelVehicle";
import FlowNumbersBox from "../components/FlowNumbersBox";
import EPRBox from "../components/EPRBox";
const RegVehComponent = ({ businessId, mainBusinessId }) => {
  const [show, setShow] = useState(false);
  return (
    <div className="reg-veh-container" id="vehicle-id">
      <RegVehHeader businessId={businessId} show={show} />
      <div style={{ display: "flex", alignItems: "center" }}>
        <ShowHide show={show} setShow={setShow} />

        <div style={{ position: "absolute", bottom: "30px", right: "14%" }}>
          <FlowNumbersBox
            isNormal={true}
            number={"Flow 2.5"}
            color={"#193666"}
          />
        </div>
      </div>
      {show && (
        <EPRBox
          businessId={businessId}
          mainBusinessId={mainBusinessId}
          category={"Registered Vehicle"}
        />
      )}
      {show && <NonFuelVehicle businessId={businessId} />}
      {show && (
        <EPRBox
          businessId={businessId}
          mainBusinessId={mainBusinessId}
          category={"Fuel Vehicle"}
        />
      )}
      {show && <FuelVehicle businessId={businessId} />}
    </div>
  );
};

export default RegVehComponent;
